module.exports = __webpack_public_path__ + "static/media/home3.cd55c8a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/home3.jpg
// module id = 541
// module chunks = 0